import { render, staticRenderFns } from "./ShiftReport.vue?vue&type=template&id=2a0e0e32&scoped=true"
import script from "./ShiftReport.vue?vue&type=script&lang=js"
export * from "./ShiftReport.vue?vue&type=script&lang=js"
import style0 from "./ShiftReport.vue?vue&type=style&index=0&id=2a0e0e32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0e0e32",
  null
  
)

export default component.exports